import { Component } from '@angular/core';
import { HeroComponent } from '../../shared/hero/hero.component';
import { FormsModule } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthServiceService } from '../../../services/authService/auth-service.service';
import { FirestoreService } from '../../../services/firestore/firestore.service';
import { UserDto } from '../../../models/user-dto';
import { CommonModule } from '@angular/common';
import { SharedService } from '../../../services/shared/shared.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { NotificationService } from '../../../services/notification/notification.service';
import { NotificationRequest } from '../../../models/notification-request';
import { EmailService } from '../../../services/email/email.service';
import { CourseApplication } from '../../../models/courseApplication';
import { Timestamp } from 'firebase/firestore';

@Component({
  selector: 'app-course-apply',
  imports: [HeroComponent, FormsModule, CommonModule],
  templateUrl: './course-apply.component.html',
  styleUrls: ['./course-apply.component.css']
})
export class CourseApplyComponent {
  isloggedIn = false;
  level!: string;
  courseData: any;
  userUid: any;
  userInfo: UserDto = {
    id: '',
    email: '',
    fullName: '',
    phoneCode: '',
    phoneNumber: ''
  };
  userIds: string[] = [];
  adminEmails: string[] = [];

  courses: any = {
    'A1-A2': {
      title: 'Anfänger-Kurse (A1–A2)',
      description: 'Beginnen Sie Ihre Reise in Deutsch! Dieser Kurs führt Sie in den Alltagsvokabular, einfache Grammatik und korrekte Aussprache ein. Am Ende werden Sie in der Lage sein, sich vorzustellen, grundlegende Fragen stellen und beantworten sowie einfache Gespräche im täglichen Leben wie Einkaufen, Reisen und Begrüßungen führen zu können.',
      image: 'assets/img/A1_A2.jpg'
    },
    'B1-B2': {
      title: 'Fortgeschrittene Kurse (B1–B2)',
      description: 'Bauen Sie Selbstvertrauen und Flüssigkeit in Deutsch auf. Dieser Kurs konzentriert sich darauf, Ihren Wortschatz zu erweitern, die Satzstruktur zu verbessern und Meinungen zu alltäglichen Themen auszudrücken. Nach Abschluss werden Sie längere Texte schreiben und lesen können, Gespräche und Medien verstehen sowie klar in sozialen und beruflichen Kontexten kommunizieren können.',
      image: 'assets/img/B1_B2.jpg'
    }
  };

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private authService: AuthServiceService,
    private firestoreService: FirestoreService,
    private sharedService: SharedService,
    private spinner: NgxSpinnerService,
    private notificationService: NotificationService,
    private emailService: EmailService,
  ) {}

  ngOnInit(): void {
    this.level = this.route.snapshot.paramMap.get('level')!;
    this.courseData = this.courses[this.level];
    this.isUserLoggedIn();
    this.firestoreService.getAdminUserIds().subscribe({
      next: res => (this.userIds = res)
    });
    this.firestoreService.getAdminsEmail().subscribe({
      next: res => (this.adminEmails = res)
    });
  }

  isUserLoggedIn() {
    this.authService.isUserLoggedIn().subscribe({
      next: res => {
        this.isloggedIn = res;
        if (!this.isloggedIn) {
          this.router.navigateByUrl('/Home');
        } else {
          this.userUid = this.authService.getCurrentUserUid();
          this.getUserInfo();
        }
      }
    });
  }

  getUserInfo() {
    this.firestoreService.getById('users', this.userUid).subscribe({
      next: res => {
        this.userInfo = res;
      }
    });
  }

  onSubmit() {
    if (!this.userInfo.fullName || !this.userInfo.email || !this.userInfo.phoneCode || !this.userInfo.phoneNumber) {
      this.sharedService.handleError(undefined,'','Bitte füllen Sie alle erforderlichen Felder aus.');
      return;
    }

    this.spinner.show();

    const request: CourseApplication = {
      userId: this.userUid,
      level: this.level,
      status: 'pending',
      userEmail: this.userInfo.email,
      userName: this.userInfo.fullName,
      phone:this.userInfo.phoneCode+this.userInfo.phoneNumber,
      userImage: this.userInfo.image||"assets/img/user.png",
      createdAt:Timestamp.now()
    };

    this.firestoreService.add('courseApplication',request).subscribe({
      next: res => {
        this.sharedService.handleSuccess(
          'Wir haben Ihre Bewerbung erhalten! ✅ Unser Admin-Team wird Sie bald kontaktieren, um Sie durch die nächsten Schritte zu führen.',
          'Bewerbung erfolgreich eingereicht!'
        );

        // Send notification
        const notificationRequest = new NotificationRequest();
        notificationRequest.title = 'Kursbewerbung erhalten';
        notificationRequest.body = `Sie haben eine neue Bewerbung für ${this.courseData.title} erhalten.`;
        notificationRequest.type = 'COURSE_APPLICATION_RECEIVED';
        notificationRequest.userIds = this.userIds;
        notificationRequest.status = 'UNREAD';
        this.notificationService.saveNotification(notificationRequest).subscribe({});

        // Send email
        const emailRequest = {
          to_name: 'Towards Germany Admin',
          reply_to: this.adminEmails,
          subject: notificationRequest.title,
          body: notificationRequest.body
        };
        this.emailService.sendEmail(emailRequest);

        this.router.navigateByUrl('/Home');
      },
      error: err => {
        this.sharedService.handleError(
          err,
          'Bewerbungsfehler',
          'Fehler beim Einreichen Ihrer Kursbewerbung.'
        );
        this.spinner.hide();
      }
    });
  }
}